import React from 'react';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMap } from 'react-map-gl';

import { CustomInputWithOutIcon } from 'handimap-react-lib/components/CustomInput';
import { setOpenSideBar } from 'handimap-react-lib/store/actions/sideBarActions';
import { GeocoderInput } from '../components/GeocoderInput';

export const SearchAddress = () => {
  const dispatch = useDispatch();
  const { mymap } = useMap();
  const { t } = useTranslation();
  const onSetAddress = (label, center) => {
    mymap.flyTo({ center: center, duration: 500 });
    dispatch(setOpenSideBar(false));
  };

  const label = () => {
    return (
      <div>
        {t('form.search-address-label')}{' '}
        <span className='hidden'>sur la carte</span>
      </div>
    );
  };

  const styles = {
    label: {
      whiteSpace: 'normal',
      color: '#FFFFFF',
    },
    inputField: {
      display: 'flex',
      width: '100%',
      borderRadius: '0.5em',
      backgroundColor: '#FFFFFF',
      '& input::placeholder': {
        fontSize: '0.8em',
        color: 'black',
        opacity: 0.6,
        paddingY: '1em',
      },
      outline: 'none',
      '& button': {
        visibility: 'visible',
      },
    },
  };

  return (
    <CustomInputWithOutIcon
      id='search-label'
      label={label()}
      roleLabel='presentation'
      styleLabel={styles.label}
    >
      <GeocoderInput
        id='search'
        describedBy='infoPointsInterets'
        labelId='search-label'
        sx={styles.inputField}
        placeholder='Ex : Avenue de La Liberté, 34070 Montpellier'
        onComplete={onSetAddress}
        inputValue=''
      />
    </CustomInputWithOutIcon>
  );
};
